import React from 'react'

import {
  ShareButtons,
  ShareCounts,
  generateShareIcon
} from 'react-share';

// *** SOCIAL SHARE ICONS *** //
const {
  FacebookShareButton,
  TwitterShareButton,  
  LinkedinShareButton,
  EmailShareButton,
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const LinkedinIcon = generateShareIcon('linkedin');
const EmailIcon = generateShareIcon('email');
// *** SOCIAL SHARE ICONS *** //

const ShareButtonsComponents = ({ location, desc }) => (
    <div className="share">
    <FacebookShareButton
        url={location}
        quote={desc}
    >
        <FacebookIcon
        size={32}
        iconBgStyle={{ fill: "#000" }} />
    </FacebookShareButton>

    <TwitterShareButton
        url={location}
        title={desc}
    >
        <TwitterIcon
        size={32}
        iconBgStyle={{ fill: "#000" }} />
    </TwitterShareButton>

    <LinkedinShareButton
        url={location}
        quote={desc}
    >
        <LinkedinIcon
        size={32}
        iconBgStyle={{ fill: "#000" }} />
    </LinkedinShareButton>
    </div>
)

export default ShareButtonsComponents


// WEBPACK FOOTER //
// ./src/__components/ShareButtons.js